import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DxButtonModule, DxDataGridModule, DxPopoverModule } from 'devextreme-angular';
import { ProjectionMethodSelectComponent } from '../projection-method-select/projection-method-select.component';
import { RevenueProjectionGridComponent } from './revenue-projection-grid.component';

@NgModule({
  declarations: [RevenueProjectionGridComponent],
  imports: [CommonModule, DxButtonModule, DxDataGridModule, DxPopoverModule, ProjectionMethodSelectComponent],
  exports: [RevenueProjectionGridComponent],
})
export class RevenueProjectionGridModule {}
